import { FilterBar } from 'foundations-components/transitional/components/FilterBar';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const InnerComponent = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  gap: "200",
  flexWrap: "nowrap",
  inlineSize: "100%",
  children: children
});
const StartComponent = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  flexShrink: 0,
  blockSize: "40px",
  children: children
});
const MiddleComponent = ({
  children
}) => /*#__PURE__*/_jsx(View, {
  overflow: "hidden",
  inlineSize: "100%",
  children: /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: "40px",
    children: children
  })
});
const EndComponent = ({
  children
}) => /*#__PURE__*/_jsx(Flex, {
  alignItems: "center",
  flexShrink: 0,
  blockSize: "40px",
  marginInlineStart: "auto",
  justifyContent: "end",
  children: children
});
export const FilterBarContainer = ({
  startSlot,
  middleSlot,
  endSlot,
  'data-onboarding': dataOnboarding,
  'data-test-id': dataTestId,
  'data-selenium-test': dataSeleniumTest
}) => /*#__PURE__*/_jsx(FilterBar, {
  "data-onboarding": dataOnboarding,
  "data-test-id": dataTestId,
  "data-selenium-test": dataSeleniumTest,
  Inner: InnerComponent,
  Start: StartComponent,
  Middle: MiddleComponent,
  End: EndComponent,
  startSlot: startSlot,
  middleSlot: middleSlot,
  endSlot: endSlot,
  flush: true,
  paddingBlockEnd: "300",
  paddingInlineStart: "0",
  paddingBlockStart: "0"
});